import { Routes } from '@/router/router.const';
import apolloClient from '@/plugins/GraphQL/Apollo/client';
import { Authentication_Get_Azuread_RouteDocument, Authentication_Get_Azuread_RouteQuery, Authentication_Get_Azuread_RouteQueryVariables } from '@/graphql/codegen/generated/graphql';

export const useAzure = () => {
  const getQueryParamsCode = () => {
    try {
      const queryString = window.location.search;
      const urlParams = new URLSearchParams(queryString);
      return urlParams.get('code');
    } catch (error) {
      return null;
    }
  };
  const getRedirectUri = () => {
    const { protocol, hostname, port } = new URL(window.location.href);
    return `${protocol}//${hostname}:${port}/${Routes.AzureCallback}`;
  };

  const handleAzureLogin = async () => {
    const redirectUri = getRedirectUri();
    const GQL_azureAD = await apolloClient.query<Authentication_Get_Azuread_RouteQuery, Authentication_Get_Azuread_RouteQueryVariables>({
      query: Authentication_Get_Azuread_RouteDocument,
      variables: {
        data: {
          redirectUri,
        },
      },
    });
    if (GQL_azureAD?.data?.authentication_get_azuread_route?.redirectUri) {
      window.location.replace(GQL_azureAD?.data?.authentication_get_azuread_route?.redirectUri);
    }
  };

  return {
    getQueryParamsCode,
    getRedirectUri,
    handleAzureLogin,
  };
};
